module.exports = __webpack_public_path__ + "static/media/nick-kane-687812-unsplash-sm.f23ab396.jpg";